import { Modal } from '../modal/modal';
import React, { useState } from 'react';
import { Api, pathJoin } from '../../../services/api';
import { Notify } from '../../../services/notification/notify';
import { useEffect } from 'react';


export const DeleteResource = ({
    resourceName,
    name,
    restEndpoint,
    customMessage = null,
    ids = [],
    successCallback = () => {},
    errorCallback = () => {},
    cancelCallback = () => {},
    prompt = false
}) => {
    const [deleteLoading, setDeleteLoading] = useState(false);

    const sendDeleteRequest = () => {
        setDeleteLoading(true);
        Api.delete(pathJoin(restEndpoint, ids.join(',')))
        .then(json => {
            if (!json.success)
                throw new Error('Error deleting ' + resourceName);
            
            Notify.success(`${resourceName} Deleted`, `The ${resourceName} has been successfully deleted.`);
            setDeleteLoading(false);
            successCallback();
        }).catch(e => {
            console.error(e);
            Notify.error('Error Deleting', `An error occurred while trying to delete the ${resourceName} and the operation could not be finished`);

            setDeleteLoading(false);
            errorCallback();
        })
    }

    return <>
        <Modal
            header={'Delete ' + resourceName}
            active={prompt}
            buttons={[
                {label: 'Cancel', primary: false, closeOnClick: true},
                {label: 'Delete', primary: true, onClick: sendDeleteRequest, disabled: deleteLoading}
            ]}
            onClose={() => {cancelCallback()}}
        >
            {customMessage !== null ? customMessage : <>
                Are you sure want to delete the selected {resourceName.toLowerCase()}? This action is irreversible and the {resourceName.toLowerCase()} can not be restored.

                <br/><br/>

                {resourceName} to delete: {name}
            </>}
        </Modal>
    </>;
}